import React from 'react'
import { ReactElement } from 'react'
import styled from 'styled-components'

import Field from '../../../../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import Textarea from '../../../../../../../../../1stlog-ui/src/components/Textarea'
import OtherFieldManipulator from './OtherFieldManipulator'

const Wrapper = styled.div`
  flex: 1 1 auto;
`

type TInputOptionProps = {
  label: string
  name: string
  readonly?: boolean
  value?: any
  placeholder?: string
}

const InputOption = (props: TInputOptionProps): ReactElement => {
  const { label, name, readonly, value: externalValue, placeholder } = props

  const value = useFieldValue<string>(name)

  return (
    <>
      {!readonly && <OtherFieldManipulator name={name} value={value} />}
      {readonly && (
        <div style={{ whiteSpace: 'pre-wrap' }}>{value || externalValue}</div>
      )}
      <Wrapper hidden={readonly}>
        <Field name={name} label={label}>
          <Textarea style={{ display: 'block' }} placeholder={placeholder} />
        </Field>
      </Wrapper>
    </>
  )
}

export default InputOption
